import { render } from "./pop.vue?vue&type=template&id=c116d2fa"
import script from "./pop.vue?vue&type=script&lang=js"
export * from "./pop.vue?vue&type=script&lang=js"

import "./pop.vue?vue&type=style&index=0&id=c116d2fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/pop.vue'],['render',render],['__file',"pop.vue"]])

export default __exports__